'use client'
import type { TextFieldProps } from '@mui/material/TextField'
import { Box, BoxProps } from '@mui/material'
import { Controller, useFormContext, useFormState } from 'react-hook-form'
// Import TextFieldCT từ common
import { TextFieldCT } from '@/components'

// ----------------------------------------------------------------------

export type RHFTextFieldProps = TextFieldProps & {
  name: string
  classContainer?: string
  width?: string | number
  boxProps?: Omit<BoxProps, 'children'>
}

export function RHFTextField({
  name,
  helperText,
  slotProps,
  classContainer,
  type = 'text',
  label,
  width = '100%',
  required,
  boxProps,
  ...other
}: RHFTextFieldProps) {
  const { control } = useFormContext()
  const { isSubmitted } = useFormState({ control })

  return (
    <Box
      {...boxProps}
      sx={{
        position: 'relative',
        width: width,
        ...boxProps?.sx,
      }}
    >
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <TextFieldCT
            {...field}
            label={label}
            type={type}
            required={required}
            width="100%"
            errorMessage={error?.message}
            helperText={helperText}
            slotProps={slotProps}
            classContainer={classContainer}
            {...other}
          />
        )}
      />
    </Box>
  )
}
